import {Component, computed, inject, output} from '@angular/core';
import {TrajetSelectionneService} from '../services/trajet-selectionne.service';
import {isNotNullOrUndefined} from '@sigale-angular/src/utils/functions';
import {TrajetService} from '../../../../shared/services/trajet.service';
import {MessageService, ConfirmationService} from 'primeng/api';
import {AlertService, ApplicationErreur} from 'sigale-angular';
import {TranslateService} from '@ngx-translate/core';
import {StatutTrajetEnum} from '../model/statut-trajet.enum';
import {RafraichissementTrajetsService} from '../services/rafraichissement-trajets.service';

@Component({
	selector: 'app-details-trajet',
	templateUrl: './detail-trajet.component.html',
	styleUrl: './detail-trajet.component.scss'
})
export class DetailTrajetComponent {
	// Constantes
	readonly NOM_ALERTE_TRAJETS = "alerteTabTrajets";

	// Injections
	private alertService = inject(AlertService);
	private confirmationService = inject(ConfirmationService);
	private messageService = inject(MessageService);
	private rafraichissementTrajetsService = inject(RafraichissementTrajetsService);
	private trajetSelectionneService = inject(TrajetSelectionneService);
	private trajetService = inject(TrajetService);
	private translateService = inject(TranslateService);

	// Outputs
	basculerEnModeModificationTrajet = output<void>();

	// Computed
	estTrajetAnnule = computed(() => this.trajet()?.statut === StatutTrajetEnum.ANNULE);
	estTrajetPasse = computed(() => new Date(this.trajet()?.dateDepart).getTime() < new Date().getTime());
	tauxRemplissage = computed(() => this.trajet().nombreReservations / this.trajet().nombrePlaces * 100);
	trajet = computed(() => this.trajetSelectionneService.trajetSelectionne());

	constructor() {
	}

	/**
	 * Désélectionne le trajet enregistré dans le service pour fermer le détail du trajet actuel.
	 */
	fermerDetailTrajet(): void {
		this.trajetSelectionneService.deselectionnerTrajet();
	}

	/**
	 * Basculer en mode modification du trajet.
	 */
	basculerEnModeModification(): void {
		if (isNotNullOrUndefined(this.trajetSelectionneService.trajetSelectionne())) {
			this.basculerEnModeModificationTrajet.emit();
		}
	}

	/**
	 * Affiche un popup de confirmation à l'utilisateur pour confirmer ou non l'annulation.
	 */
	afficherConfirmationAnnulation(): void {
		this.confirmationService.confirm({
			message: this.translateService.instant('GESTION_NAVETTE.TRAJETS.ANNULATION.MESSAGE_ANNULATION'),
			header: this.translateService.instant('GESTION_NAVETTE.TRAJETS.ANNULATION.ANNULATION_TRAJET_TITRE'),
			acceptLabel: this.translateService.instant('GESTION_NAVETTE.TRAJETS.ANNULATION.CONFIRMATION_ANNULATION'),
			rejectLabel: this.translateService.instant('GLOBAL.BTN_FERMER'),
			acceptButtonStyleClass: 'p-button-danger',
			rejectButtonStyleClass: 'p-button-link',
			accept: () => {
				this.annulerTrajet();
			}
		});
	}

	/**
	 * Lance l'annulation du trajet sélectionné.
	 */
	private annulerTrajet(): void {
		if (isNotNullOrUndefined(this.trajet())) {
			this.trajetService.annulerTrajet(this.trajet().id).subscribe({
				next: () => {
					this.messageService.add({ severity: 'success', detail: this.translateService.instant('GESTION_NAVETTE.TRAJETS.MESSAGE_ANNULATION_TRAJET_SUCCES') });
					this.rafraichissementTrajetsService.demanderRafraichissement();
				},
				error: (erreur: ApplicationErreur) => {
					this.alertService.clear(this.NOM_ALERTE_TRAJETS);
					this.alertService.error(erreur, this.NOM_ALERTE_TRAJETS);
				}
			});
		}
	}
}
